import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../api/connector'

interface ApplicationSessionArgs {
  organizationUuid: string
  applicationUuid: string
}
interface TotalApplicationCustomAgentSessionsResponse {
  customTotal
}

export async function getTotalApplicationCustomAgentSessions(
  this: ThisConnector,
  { applicationUuid, organizationUuid }: ApplicationSessionArgs
) {
  return this.connector.get(
    `/organizations/${organizationUuid}/applications/${applicationUuid}/agent-sessions`
  )
}

export const useTotalApplicationCustomAgentSessions = ({
  applicationUuid,
  organizationUuid
}) => {
  const { data } = useContrastQuery<
    ApplicationSessionArgs,
    TotalApplicationCustomAgentSessionsResponse
  >(
    [Query.TOTAL_APP_CUSTOM_AGENT_SESSION, organizationUuid, applicationUuid],
    getTotalApplicationCustomAgentSessions,
    {
      applicationUuid,
      organizationUuid
    }
  )

  return {
    data
  }
}
